namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoHdColumns {
        static columnsKey = 'AdvPromo.PsAdvPromoHd';
    }
}
